export const navItems = [
  {
    name: 'Accueil',
    to: '/',
    subLinks: [
      { name: 'Présentation', to: '/' },
      { name: 'Témoignages', to: '/' }
    ]
  },
  {
    name: 'À propos',
    to: '/about',
    subLinks: [
      { name: 'Notre histoire', to: '/about' },
      { name: 'Notre équipe', to: '/about' }
    ]
  },
  {
    name: 'Boutique',
    to: '/products',
    subLinks: [
      { name: 'Psaumes', to: '/products' },
      { name: 'Plantes', to: '/products' }
    ]
  },

{
    name: 'blog',
    to: '/blog',
   subLinks: [
      { name: 'Actualités', to: '/blog' },
      { name: 'Conseils', to: '/blog' }
    ]
  },

  {
    name: 'Contact',
    to: '/contact',
    subLinks: [
      { name: 'Email', to: '/contact' },
      { name: 'Téléphone', to: '/contact' }
    ]
  }
];